import { Grid } from "@mui/material";
import type { AutoTransactionRuleDto } from "../../../../api/types";
import { AutoTransactionTile } from "./AutoTransactionTile";
import type { Selection } from "./AutoTransactionListView";

export type AutoTransactionTileViewProps = {
  rules: AutoTransactionRuleDto[];
  togglingId: string | null;
  selection?: Selection | null;
  onEdit: (rule: AutoTransactionRuleDto) => void;
  onDuplicate: (rule: AutoTransactionRuleDto) => void;
  onPreviewMatches: (rule: AutoTransactionRuleDto) => void;
  onShowApplied: (rule: AutoTransactionRuleDto) => void;
  onDelete: (rule: AutoTransactionRuleDto) => void;
  onToggleEnabled: (rule: AutoTransactionRuleDto, next: boolean) => void;
};

export const AutoTransactionTileView = ({
  rules,
  togglingId,
  selection,
  onEdit,
  onDuplicate,
  onPreviewMatches,
  onShowApplied,
  onDelete,
  onToggleEnabled,
}: AutoTransactionTileViewProps) => (
  <Grid container spacing={2}>
    {rules.map((rule) => (
      <Grid key={rule.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
        <AutoTransactionTile
          rule={rule}
          isTogglingEnabled={togglingId === rule.id}
          selection={
            selection
              ? {
                  selected: selection.selectedIds.has(rule.id),
                  onToggle: () => selection.onToggle(rule.id),
                }
              : null
          }
          onEdit={onEdit}
          onDuplicate={onDuplicate}
          onPreviewMatches={onPreviewMatches}
          onShowApplied={onShowApplied}
          onDelete={onDelete}
          onToggleEnabled={onToggleEnabled}
        />
      </Grid>
    ))}
  </Grid>
);
